var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachmentIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon attachment-icon",
    width: 14,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61 1.609a5.496 5.496 0 017.612-.153l.158.153 4.4 4.4a.748.748 0 01-.983 1.126l-.076-.067-4.4-4.399a3.996 3.996 0 00-5.79 5.507l.139.145 5.454 5.454a2.497 2.497 0 003.644-3.413l-.113-.12-5.454-5.454a1 1 0 00-1.49 1.326l.078.087 4.399 4.4a.75.75 0 01-.982 1.127l-.077-.067-4.4-4.4A2.498 2.498 0 017.14 3.616l.12.113 5.454 5.453a3.997 3.997 0 01-5.507 5.79l-.144-.138L1.61 9.38a5.495 5.495 0 010-7.771",
    fill: "gray",
    fillRule: "evenodd"
  })));
}

export default SvgAttachmentIconSv;